<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure>
                          <img :src="$iconFolder + 'payment/' + (resource.provider ? resource.provider.id : 'none') + '.svg'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Profile <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                      <notice-published v-model="resource" label-published="Méthode de paiement active." label-unpublished="Méthode de paiement inactive." :dates="false"></notice-published>
                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>
                                <form-select label="Provider" multiple="false" v-model="resource.provider" :default="resource.provider" :options="gateways" :required="true"></form-select>

                                <form-toggle label="Paiement direct" v-model="resource.payment_onsite" hint="Si il s'agit d'un type de paiement cash, comptant ou par cartes de crédit, veuillez cocher la case."></form-toggle>

                                <form-toggle label="Proposer ce paiement aux clients de votre site" v-model="resource.is_online" hint="Cocher la case si vous souhaitez que ce paiement apparaisse dans le checkout."></form-toggle>

                                <group-line-3>
                                  <form-toggle label="Somme" v-model="resource.is_number"></form-toggle>
                                  <form-text label="Frais de transaction" v-model="resource.cost_value" :suffix="resource.is_number?$store.state.scope.currency_id:'%'"></form-text>
                                  <form-select label="Taxe" multiple="false" v-model="resource.tax" :default="resource.tax_id" :options="$store.state.taxes" :required="true"></form-select>
                                </group-line-3>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text :translate-key="'name'" :translations="resource.translations" :lang="client.id" :label="'Nom'" v-model="resource.translations[client.id].name" :required="true"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text :translate-key="'headline'" :translations="resource.translations" :lang="client.id" label="Description courte" v-model="resource.translations[client.id].headline" :required="true"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-html :translate-key="'description'" :translations="resource.translations" label="Description" :lang="client.id" :tag="'textarea'" v-model="resource.translations[client.id].description"></form-html>
                                  </div>
                                </div>

                              </fieldset>

                            </tab>
                            <tab name="Notification e-mail">

                              <fieldset>
                                <h3>Notification e-mail</h3>
                                <p class="headline"></p>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-html :translate-key="'customer_order_success'" :translations="resource.translations" label="Message au client" :lang="client.id" :tag="'textarea'" v-model="resource.translations[client.id].customer_order_success"></form-html>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-html :translate-key="'administrator_order_success'" :translations="resource.translations" label="Message à l'administrateur" :lang="client.id" :tag="'textarea'" v-model="resource.translations[client.id].administrator_order_success"></form-html>
                                  </div>
                                </div>

                              </fieldset>

                            </tab>
                            <tab name="Etablissement bancaire">

                                <fieldset v-if="resource.provider && (resource.provider.id == 'banktransfer' || resource.provider.id == 'invoice')">
                                  <h3>Informations de paiement</h3>
                                  <p class="headline"></p>

                                  <div class="selector">
                                    <label @click="selectType(false)" v-bind:class="{'active':!resource.is_qr_iban}">
                                      <i class="icon icon-qr-code"></i>
                                      <div>
                                        <strong>QR Facture</strong>
                                        <p>Bulletin simple, sans référence</p>
                                      </div>
                                    </label>
                                    <label @click="selectType(true)" v-bind:class="{'active':resource.is_qr_iban}">
                                      <i class="icon icon-qr-code"></i>
                                      <div>
                                        <strong>QR Iban</strong>
                                        <p>Bulletin avec référence</p>
                                      </div>
                                    </label>
                                  </div>

                                  <div v-if="resource.is_qr_iban">
                                    <form-text label="QR IBAN" v-model="resource.bank_qr_iban" :required="true"></form-text>
                                    <form-text label="BESR ID (Génération de référence)" v-model="resource.bank_besr_id"></form-text>
                                  </div>
                                  <div v-else>
                                    <form-text label="IBAN" v-model="resource.bank_iban" :required="true"></form-text>
                                    <form-text label="Etablissement bancaire" v-model="resource.bank_name"></form-text>
                                    <form-text label="Compte bancaire" v-model="resource.bank_account_number"></form-text>
                                    <form-text label="BIC/SWIFT" v-model="resource.bank_bic"></form-text>
                                  </div>
                                </fieldset>


                            </tab>
                            <tab name="Avancé">

                              <fieldset>
                                <h3>Configuration avancée</h3>
                                <p class="headline"></p>

                                <form-file label="Logo" v-model="resource.picture_id" width="300"></form-file>

                                <form-numeric label="Order" v-model="resource.ord"></form-numeric>

                                <div v-for="variable in variables" v-if="variables">
                                  <form-text :label="variable.id" v-model="variable.value"></form-text>
                                  <button @click="deleteVar(variable.id)" class="bt-remove"><span class="icon icon-icon_close"></span></button>
                                </div>
                                <button-action label="Add field" type="create" @callback="addVar()" />

                              </fieldset>

                            </tab>
                            <tab name="Conditions">

                              <fieldset>
                                <h3>Conditions</h3>
                                <p class="headline"></p>

                                <component-conditions v-model="resource.conditions" :options="options_default" :datas="option_datas"></component-conditions>
                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import PaymentService from './PaymentService.js';
    import Edit from '../../../layouts/Edit.vue';
    import ComponentConditions from "../../../components/Conditions.vue";


    export default {
        extends: Edit,
        components: {
            'component-conditions': ComponentConditions
        },
        data () {
            return {
                resource: {
                },
                options: [],
                companies: [],
                isLoading: false,
                variables: [],
                gateways: [
                    {id:'stripe', name:'Stripe'},
                    {id:'datatrans', name:'Datatrans'},
                    {id:'datatrans-swissbilling', name:'Swissbilling (datatrans)'},
                    {id:'datatrans-twint', name:'Twint (datatrans)'},
                    {id:'datatrans-paypal', name:'PayPal (datatrans)'},
                    {id:'paypal', name:'PayPal'},
                    {id:'banktransfer', name:'Bank Transfer'},
                    {id:'saferpay', name:'Saferpay (sixpayment)'},
                    {id:'heidipay', name:'Heidipay'},
                    {id:'invoice', name:'Invoice'}
                ],
                options_default: [
                    {
                        id:"country",
                        name: "Pays",
                        options: 'countries',
                        operators:[
                            {id:'egal', name:'='},
                            {id:'in', name:'in (..., ...)'},
                            {id:'contain', name:'contains'}
                        ]
                    },
                    {
                        id:"subtotal",
                        name: "Sous-total HT",
                        operators:[
                            {id:'egal', name:'='},
                            {id:'greater_than', name:'>'},
                            {id:'egal_greater_than', name:'>='},
                            {id:'less_than', name:'<'},
                            {id:'egal_less_than', name:'<='},
                            {id:'not_egal', name:'!='}
                        ]
                    },
                    {
                        id:"totalPackageWeight",
                        name: "Poids en grammes",
                        operators:[
                            {id:'egal', name:'='},
                            {id:'greater_than', name:'>'},
                            {id:'egal_greater_than', name:'>='},
                            {id:'less_than', name:'<'},
                            {id:'egal_less_than', name:'<='},
                            {id:'not_egal', name:'!='}
                        ]
                    },
                    {
                      id:"paymentCondition",
                      name: "Conditions de paiement",
                      options: 'payment_conditions',
                      operators:[
                        {id:'in', name:'in ...'},
                        {id:'not_in', name:'not in ...'}
                      ]
                    }
                ]
            }
        },
        mounted: function(){
          this.option_datas = {}
          this.option_datas.payment_conditions = this.$store.getters.scope.payment_conditions;
          this.option_datas.countries = this.$store.state.countries;
        },
        methods:{
            selectType: function(bool)
            {
              this.resource.is_qr_iban = bool;
              this.$forceUpdate()
            },
            resourceLoaded: function(){
                this.setTranslations(['name','headline','description','customer_order_success','administrator_order_success']);
                this.resource.config = this.resource.config;
                this.resource.conditions = this.resource.conditions||[];
                this.variables = []
                for (var key in (this.resource.config)) {
                    if (this.resource.config.hasOwnProperty(key)) {
                        this.variables.push({id:key, value:this.resource.config[key]});
                    }
                }

                /* CONVERT DATES TO LOCAL TIMZONE */
                this.resource.start_at = this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone).format() : null;
                this.resource.end_at = this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone).format() : null;
                /*****/

                this.initialize()
            },
            beforeUpdate: function(Resource){
                this.updateVars();
                return true;
            },
            updateVars: function(){
                let obj = {};
                for (var i=0 ; i<this.variables.length ; i++) {
                    obj[this.variables[i].id] = this.variables[i].value;
                }
                this.resource.config = obj;
            },
            addVar: function(){
                let id = prompt('Variable name ?');
                this.variables.push({id:id,value:""});
                this.updateVars();
            },
            deleteVar: function(id){
                let index = null;
                for (var i=0 ; i<this.variables.length ; i++) {
                    if (this.variables[i].id == id) {
                        index = i;
                        break;
                    }
                }
                if( index != null ){ this.variables.splice(index,1); }
                this.updateVars();
            },
            getResource: function(){
                return PaymentService
            },
            limitText (count) {
                return `and ${count} other countries`
            },
            asyncFind (query) {
                this.isLoading = true
                PaymentService.query('?query=' + query ).then(response => {
                    this.companies = response.data.data
                    this.isLoading = false
                })
            },
            clearAll () {
                this.resource.companies = []
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/config/payment/Edit.vue